// src/Redux/Auth/TokenSlice.js
import { createSlice } from "@reduxjs/toolkit";

const TokenSlice = createSlice({
  name: "token",
  initialState: {
    value: null,
  },
  reducers: {
    setToken: (state, action) => {
      state.value = action.payload;
    },
    clearToken: (state) => {
      state.value = null;
    },
  },
});

export const { setToken, clearToken } = TokenSlice.actions;
export default TokenSlice.reducer;
